export default "__VITE_ASSET__85946096__"